import { useEffect } from 'react';
import socket from '../utils/socket';

export default function useSocket(warehouseId, handlers = {}) {
    // handlers を配列にして useEffect 内で固定
    const entries = Object.entries(handlers);

    useEffect(() => {
        if (!warehouseId) return;

        // 入室
        socket.emit('join-warehouse', warehouseId);

        // イベント登録
        entries.forEach(([event, handler]) => {
            socket.on(event, handler);
        });

        return () => {
            // 退出
            socket.emit('leave-warehouse', warehouseId);

            // イベント解除
            entries.forEach(([event, handler]) => {
                socket.off(event, handler);
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [warehouseId, ...entries.map(([_, h]) => h)]);
}
